(window.MyModule = function ($, Behaviors) {

    "use strict";

    var module = {};

    /**
     * URL Parameters
     */
    function generateUrlParameters(productCategory = '', cameraType = '', model = '', isDiscontinued) {
        var urlParameters = '';

        // if (productCategory.length > 0) {
        //     urlParameters += 'product-category=' + productCategory;
        // }

        // if (cameraType) {
        //     urlParameters += urlParameters ? '&' : '';
        //     urlParameters += 'camera-type=' + cameraType;
        // }

        if (model) {
            urlParameters += urlParameters ? '&' : '';
            urlParameters += 'model=' + model;
        }

        if (isDiscontinued === '1') {
            urlParameters += urlParameters ? '&' : '';
            urlParameters += 'discontinued=1';
        }

        urlParameters = urlParameters ? '?' + urlParameters : ' ';

        if (urlParameters.length > 1) {
            history.replaceState(undefined, undefined, urlParameters);
        } else {
            history.replaceState(undefined, undefined, '?');
        }
    }

    /**
     * Get Tags
     */
    function getFilterTags($thisElem) {
        var tagsWrap = $thisElem.find('.OEDocumentationFilters-tags');

        tagsWrap.empty();

        if ($thisElem.data('main-category').length > 0) {
            tagsWrap.append('<span class="OEDocumentationFilters-tag" data-filter="' + $thisElem.data('main-category') + '">' + $thisElem.data('main-category') + '</span>');
        }
        //
        // console.log($thisElem.data('acf-category'));
        // if ($thisElem.data('acf-category').length > 0) {
        //     tagsWrap.append('<span class="OEDocumentationFilters-tag" data-filter="' + $thisElem.data('acf-category') + '">' + $thisElem.data('acf-category') + '</span>');
        // }

        $thisElem.find('.OEDocumentationFilters-dropdown-filter.active').each(function () {
            var temp = $(this).html(),
                dataFilter = $(this).data('filter');

            tagsWrap.append('<span class="OEDocumentationFilters-tag" data-filter="' + dataFilter + '">' + temp + '</span>');
        });

        if ($thisElem.find('.OEDocumentationFilters-dropdown-filter.active').length > 0) {
            tagsWrap.addClass('show');
        } else {
            tagsWrap.removeClass('show');
        }
    }

    /**
     * Get Model
     */
    function modelApi($thisElem) {
        var productCategory = $thisElem.data('main-category').length > 0 ? $thisElem.data('main-category') : '',
            acfCategory = $thisElem.data('acf-category').length > 0 ? $thisElem.data('acf-category') : '',
            cameraType = $thisElem.find('.OEDocumentationFilters-dropdown-filter-camera_type.active').length > 0 ? $thisElem.find('.OEDocumentationFilters-dropdown-filter-camera_type.active').data('filter') : '',
            model = $thisElem.find('.OEDocumentationFilters-dropdown-filter-model.active').length > 0 ? $thisElem.find('.OEDocumentationFilters-dropdown-filter-model.active').data('filter') : '',
            discontinued = $thisElem.find('input[name="show_discontinued"]').is(':checked');

      discontinued = discontinued === true ? '1' : '0';

      console.log(model);

      $.ajax({
            url: wpAjaxUrl, // AJAX handler
            data: {
                'action': 'documentation_model',
                productCategory: productCategory,
                acfCategory: acfCategory,
                cameraType: cameraType,
                model: model,
                discontinued: discontinued
            },
            type: 'POST',
            beforeSend: function (xhr) {
                $thisElem.addClass('OE--loading');
            },
            success: function (data) {

                if (productCategory == 'cameras') {
                    if (!cameraType) {
                        $thisElem.find('#OEDocumentationFilters-dropdown-2').remove();
                    }
                } else {
                    $thisElem.find('#OEDocumentationFilters-dropdown-2 .active').removeClass('active');
                }

                $thisElem.find('#OEDocumentationFilters-dropdown-3').remove();

                $thisElem.find('#OEDocumentationFilters-dropdown-4').remove();

                $thisElem.find('.OEDocumentationFilters-dropdowns').append(data);

                $thisElem.removeClass('OE--loading');

                $thisElem.removeClass('OEDocumentationFilters--init_display');

            }
        });
        return false;
    }

    /**
     * Get Products
     */
    function documentationApi($thisElem) {
        var filterDropdown = $thisElem.find('.OEDocumentationFilters-nav a'),
            loop = $thisElem.find('.OEDocumentationFilters-loop'),
            productCategory = $thisElem.data('main-category').length > 0 ? $thisElem.data('main-category') : '',
            acfCategory = $thisElem.data('acf-category').length > 0 ? $thisElem.data('acf-category') : '',
            cameraType = $thisElem.find('.OEDocumentationFilters-dropdown-filter-camera_type.active').length > 0 ? $thisElem.find('.OEDocumentationFilters-dropdown-filter-camera_type.active').data('filter') : '',
            model = $thisElem.find('.OEDocumentationFilters-dropdown-filter-model.active').length > 0 ? $thisElem.find('.OEDocumentationFilters-dropdown-filter-model.active').data('filter') : '',
            discontinued = $thisElem.find('input[name="show_discontinued"]').is(':checked');

        discontinued = discontinued === true ? '1' : '0';
        // Url parameters
        // generateUrlParameters(productCategory, cameraType, model, discontinued);

        $.ajax({
            url: theme_ajax_url, // AJAX handler
            data: {
                'action': 'documentation_products',
                productCategory: productCategory,
                acfCategory: acfCategory,
                cameraType: cameraType,
                model: model,
                discontinued: discontinued
            },
            type: 'POST',
            beforeSend: function (xhr) {
                $thisElem.addClass('OE--loading');

                $thisElem.find('.OEDocumentationFilters-dropdown').removeClass('open');
                filterDropdown.removeClass('active');
            },
            success: function (data) {
                loop.html(data);

                getFilterTags($thisElem);

                $thisElem.removeClass('OE--loading');

                $thisElem.removeClass('OEDocumentationFilters--init_display');
            }
        });


        return false;
    }

    function OEDocumentationFilters(elem) {
        Behaviors.init(OEDocumentationFilters, this, arguments);

        var $thisElem = this.$elem,
            filterDropdown = $thisElem.find('.OEDocumentationFilters-nav a:not(.OEDocumentationFilters-nav-all)');

        /**
         * Filters Dropdown
         */
        filterDropdown.on('click', function (e) {
            e.preventDefault();

            var $this = $(this),
                dropdown = $this.attr('href');

            if ($this.hasClass('active')) {
                $this.removeClass('active');
                $thisElem.find('.OEDocumentationFilters-dropdown').removeClass('open');
            } else {
                filterDropdown.removeClass('active');
                $thisElem.find('.OEDocumentationFilters-dropdown').removeClass('open');
                $this.addClass('active');
                $(dropdown).addClass('open');
            }
        });

        /**
         * Filters
         */
        $thisElem.on('click', '.OEDocumentationFilters-dropdown-filter:not(.OEDocumentationFilters-dropdown-filter-document_type)', function (e) {
            e.preventDefault();

            var $this = $(this),
                filterVal;

            if ($this.hasClass('OEDocumentationFilters-dropdown-filter--product_category')) {
                $thisElem.find('#OEDocumentationFilters-dropdown-2').remove();
                $thisElem.find('#OEDocumentationFilters-dropdown-3').remove();
            }
            if ($this.hasClass('OEDocumentationFilters-dropdown-filter-camera_type')) {
                $thisElem.find('#OEDocumentationFilters-dropdown-3').remove();

            }

            if ($this.hasClass('active')) {
                $this.parent().find('.OEDocumentationFilters-dropdown-filter').removeClass('active');

            } else {
                $this.parent().find('.OEDocumentationFilters-dropdown-filter').removeClass('active');
                $this.addClass('active');

                filterVal = $this.data('filter');
            }

            // if (!$this.hasClass('OEDocumentationFilters-dropdown-filter-model')) {
            modelApi($thisElem);
            // }

            if (filterVal.length > 0) {
                if (filterVal == 'cameras') {
                    $thisElem.find('.OEDocumentationFilters-nav-filter--2').removeClass('hidden');
                } else {
                    $thisElem.find('.OEDocumentationFilters-nav-filter--2').addClass('hidden');
                }

                $thisElem.find('.OEDocumentationFilters-nav-filter--3').removeClass('hidden');
            }

            documentationApi($thisElem);
        });

        $thisElem.on('click', '.OEDocumentationFilters-dropdown-filter-document_type', function (e) {
            e.preventDefault();

            const $this = $(this),
                filterVal = $this.data('filter');

            const allTypes = $thisElem.find('#OEDocumentationFilters-dropdown-4')[0].querySelectorAll('.OEDocumentationFilters-dropdown-filter-document_type');

            allTypes.forEach(type => {
                type.classList.remove('active');
            });

            e.target.classList.add('active');

            //if filter All just show all of them
            if (filterVal === 'all') {
                $thisElem[0].querySelectorAll('.OEDocumentation-part').forEach(function (element) {
                    element.style.display = 'flex';
                });

                return;
            }

            $thisElem[0].querySelectorAll('.OEDocumentation-part').forEach(function (element) {
                if (element.dataset.partType !== filterVal) {
                    element.style.display = 'none';
                } else {
                    element.style.display = 'flex';
                }
            });
        });


        let queryParam = $thisElem.data('acf-category').length > 0 ? $thisElem.data('acf-category') : '';
        queryParam = queryParam.toLowerCase();

        if(queryParam && queryParam === 'firmware') {
            document.querySelector('.OEDocumentationFilters-dropdown-filter[data-filter="Firmware"]').click();
        }

        // if (queryParam && ['all', 'user manual', 'quick start guide', 'ae spec', 'spec sheet', 'installation guide', 'accessory tree', 'line card', 'firmware', 'utility'].contains(queryParam)) {
        //     $thisElem[0].querySelectorAll('.OEDocumentation-part').forEach(function (element) {
        //         if (element.dataset.partType.toLowerCase() !== queryParam) {
        //             element.style.display = 'none';
        //         } else {
        //             element.style.display = 'flex';
        //         }
        //     });
        // }

        /**
         * Remove Filters
         */

        $(document).on('click', '.OEDocumentationFilters-tag .remove-filter', function () {
            var $this = $(this),
                dataFilter = $this.parent().data('filter'),
                targetElem = $thisElem.find('.OEDocumentationFilters-dropdown-filter[data-filter="' + dataFilter + '"]');

            targetElem.removeClass('active');

            if (targetElem.hasClass('OEDocumentationFilters-dropdown-filter--product_category')) {
                $thisElem.find('.OEDocumentationFilters-dropdown-filter.active').removeClass('active');

                $('.OEDocumentationFilters-nav-filter--2').addClass('hidden');
                $('.OEDocumentationFilters-nav-filter--3').addClass('hidden');
                $('#OEDocumentationFilters-dropdown-2').remove();
                $('#OEDocumentationFilters-dropdown-3').remove();
            }

            if (targetElem.hasClass('OEDocumentationFilters-dropdown-filter-camera_type')) {
                $thisElem.find('.OEDocumentationFilters-dropdown-filter-model.active').removeClass('active');
            }

            modelApi($thisElem);

            documentationApi($thisElem);
        });

        /**
         * Clear All Filters
         */
        // $thisElem.find('.OEDocumentationFilters-nav-all').on('click', function (e) {
        //     e.preventDefault();

        //     $thisElem.find('.OEDocumentationFilters-dropdown-filter.active').removeClass('active');

        //     $('.OEDocumentationFilters-nav-filter--2').addClass('hidden');
        //     $('.OEDocumentationFilters-nav-filter--3').addClass('hidden');
        //     $('#OEDocumentationFilters-dropdown-2').remove();
        //     $('#OEDocumentationFilters-dropdown-3').remove();

        //     modelApi($thisElem);

        //     documentationApi($thisElem);

        // });

        $thisElem.find('.OEDocumentationFilters-search').on('submit', function (e) {
            e.preventDefault();
            var searchTerm = $(this).find('input').val(),
                productCategory = $thisElem.data('main-category').length > 0 ? $thisElem.data('main-category') : '',
                loop = $thisElem.find('.OEDocumentationFilters-loop');

            // Url parameters
            // generateUrlParameters();

            $.ajax({
                url: theme_ajax_url, // AJAX handler
                data: {
                    'action': 'documentation_search',
                    searchTerm: searchTerm,
                    productCategory: productCategory
                },
                type: 'POST',
                beforeSend: function (xhr) {
                    $thisElem.addClass('OE--loading');

                    $('.OEDocumentationFilters-nav-filter--2').addClass('hidden');
                    $('.OEDocumentationFilters-nav-filter--3').addClass('hidden');
                    $('#OEDocumentationFilters-dropdown-2').remove();
                    $('#OEDocumentationFilters-dropdown-3').remove();
                },
                success: function (data) {
                    loop.html(data);

                    $thisElem.removeClass('OE--loading');

                    $thisElem.removeClass('OEDocumentationFilters--init_display');
                }
            });
            return false;
        });

        // See More
        $thisElem.find('.OEDocumentationFilters-see_more a').on('click', function (e) {
            e.preventDefault();

            $thisElem.removeClass('OEDocumentationFilters--init_display');
        });

        //Show Discontinued
        $thisElem.find('input[name="show_discontinued"]').on('change', function (e) {
            modelApi($thisElem);
            documentationApi($thisElem);
        });

        //Change layout
        $thisElem.find('.OEDocumentationLayout ul').on('click', function (e) {
            const {target} = e;
            if(!target.matches('li')) {
                return false;
            }

            const container = $thisElem.find('.OEDocumentationFilters-loop');
            if(target.classList.contains('OEDocumentationLayout__List')) {
                $thisElem.find('.OEDocumentationLayout__Grid').removeClass('active');
                target.classList.add('active');
                container.removeClass('gridView');
                container.addClass('listView');
            } else {
                $thisElem.find('.OEDocumentationLayout__List').removeClass('active');
                target.classList.add('active');
                container.removeClass('listView');
                container.addClass('gridView');
            }
        });
    }

    Behaviors.inherit(OEDocumentationFilters, Behaviors.Behavior);

    OEDocumentationFilters.QUERY = "[data-documentation-filters]";

    Behaviors.register_behavior(OEDocumentationFilters);

    module.OEDocumentationFilters = OEDocumentationFilters;

    return module;

}(window.jQuery, window.Behaviors));